import { ContactApi } from '../contact/api/contact-api';
import { CustomerApi } from '../customer/api/customer-api';
import { SupplierApi } from '../supplier/api/supplier-api';

export class ContactsAndOrganizationsApi {
    constructor(protected baseUrl: string) {
        this.Supplier = new SupplierApi(this.baseUrl);
        this.Customer = new CustomerApi(this.baseUrl);
        this.Contact = new ContactApi(this.baseUrl);
    }

    public Supplier: SupplierApi;
    public Customer: CustomerApi;
    public Contact: ContactApi;
}
